export const PREFIX = 'nextgen-theme'
export const DOT_PREFIX = `.${PREFIX}`
